import * as React from "react";
import styled from "styled-components";

import Translate from "../../common/components/Translate";

interface Props {
  text: string;
  expanded: boolean;
  limit: number;
  showMoreText?: string;
  showMoreStyle?: ShowMoreProps;
  onExpand(): void;
}

interface ShowMoreProps {
  color?: string;
  fontWeight?: number | string;
}

class ExpandableText extends React.Component<Props> {
  public onClickShowMore = () => {
    this.props.onExpand();
  };

  public render() {
    const { text, expanded, limit, showMoreText, showMoreStyle } = this.props;
    return (
      <span>
        {expanded || text.length <= limit ? (
          text
        ) : (
          <>
            {`${text.slice(0, limit)}...`}
            <ShowMore {...showMoreStyle} onClick={this.onClickShowMore}>
              {showMoreText || <Translate id="shared.show_more" />}
            </ShowMore>
          </>
        )}
      </span>
    );
  }
}

const ShowMore = styled.span`
  color: ${(props: ShowMoreProps) => props.color || "inherit"};
  font-weight: ${(props: ShowMoreProps) => props.fontWeight || "inherit"};
  margin-left: 3px;
  cursor: pointer;
`;

export default ExpandableText;



// WEBPACK FOOTER //
// ./frontend/src/common/components/ExpandableText.tsx